import * as z from 'zod';
import { bidBondAmountTypeSchema } from '../../../../../enums.mjs';
import { isoDateSchema, percentSchema } from '../../../../opaque.mjs';
import { currencySchema } from '../../../../utils.mjs';
import { Data as Data$1 } from './issued-contract-surety-bond-form.types.mixins.mjs';

var Data;
(function (Data) {
    let FillData;
    (function (FillData) {
        FillData.schema = Data$1.FillData.baseSchema.extend({
            projectDescription: z.string(),
            bidBondAmountType: bidBondAmountTypeSchema,
            bondAmountPercentOfBid: percentSchema,
            bidAmount: currencySchema,
            bidDate: isoDateSchema,
        });
    })(FillData = Data.FillData || (Data.FillData = {}));
    let Attributes;
    (function (Attributes) {
        Attributes.schema = Data$1.Attributes.baseSchema.extend({
            cancellable: z
                .boolean()
                .default(false)
                .refine((val) => val === false),
            continuous: z
                .boolean()
                .default(true)
                .refine((val) => val === true),
            renewable: z
                .boolean()
                .default(false)
                .refine((val) => val === false),
        });
    })(Attributes = Data.Attributes || (Data.Attributes = {}));
    Data.schema = z.object({
        suretyType: z.literal("contract"),
        contractSuretyType: z.literal("bid"),
        bondFormType: z.literal("bid"),
        fillData: FillData.schema,
        attributes: Attributes.schema,
    });
})(Data || (Data = {}));

export { Data };
